export default __webpack_public_path__ + "assets/images/feeebbb24ae837f6f7e6f382b3572b71.png";